export default "__VITE_ASSET__Dkc6wZL3__"